import { ShareClient } from "@formant/core/client/ShareClient";
import { defined } from "@formant/core/common/defined";
import { IShare } from "@formant/core/model/IShare";
import { IShareQuery } from "@formant/core/model/IShareQuery";

import { IAuthStore } from "./IAuthStore";
import { StoreCache } from "./StoreCache";

export class ShareStore {
    private cache = new StoreCache<string, IShare | false>();
    private listCache = new StoreCache<string, IShare[]>();
    private queryListCache = new StoreCache<string, IShare[]>();

    constructor(
        private shareClient: ShareClient,
        private authStore: IAuthStore,
    ) {}

    public getByCode(code: string): IShare | false | undefined {
        return this.cache.get(code, async () => {
            return (await this.shareClient.getByCode(code)) || false;
        });
    }

    public list(): IShare[] | undefined {
        return this.listCache.get(
            "shares",
            async () =>
                await this.shareClient.list(await this.authStore.token()),
        );
    }

    public filter(data: IShareQuery): IShare[] | undefined {
        return this.queryListCache.get(
            JSON.stringify(data),
            async () =>
                await this.shareClient.filter(
                    await this.authStore.token(),
                    data,
                ),
        );
    }

    public async revoke(share: IShare) {
        const { shareClient, listCache } = this;
        await shareClient.delete(
            await this.authStore.token(),
            defined(share.code),
        );
        listCache.clear();
    }

    public clearList() {
        this.listCache.clear();
    }
}
